import subject from '../auth';

import Channel from '../utils/channel';
import immortal from '../utils/immortal';
import ws from '../http/ws';

import { getLocations } from '../ds/task.assignee.locations';

const storage = {};

const initialLocationsQuery = subject.then( () => getLocations() )
    .then( ({ users }) => users )
    .then( response => response.filter( item => !!item.location ) )
    .then( response => response.filter( item => !!item.location.date ) )
    .then( locationsResponse => handleLocations( locationsResponse ) )
    .then( () => undefined );

const Locations = new Channel( writeFn => initialLocationsQuery
    .then( () => immortal( () => ws( '/users/locations/live' ),  
        5, // 5 attempts
        15 * 1000, // in 15 secs each,
        5 * 60 * 1000 // reconnecting in 5 min 
        ) )
    .then( ch => ch.dest( writeFn ) ) )
    .map( ({ points }) => points );

Locations.ready = () => initialLocationsQuery;

Locations.getLoc = userId => storage[userId];

Locations.forEach( locations => handleLocations( locations ) );

export default Locations;

function handleLocations(locations) {
    locations.forEach( locationInfo => {
        const { user: { id }, location } = locationInfo;
        storage[id] = location;
    } );
} 



// WEBPACK FOOTER //
// ./src/js/service/locations.js